import { FormValues, FormOverrides } from '@wix/form-viewer';

/**
 * Core type for form field configuration - simplified version without services
 */
export interface WaiverFormsFieldProperties {
  [key: string]: {
    required: boolean;
    hidden: boolean;
    fieldType: string;
  };
}

/**
 * Main form state structure for waivers
 */
export type WaiverForms = {
  initialValues: FormValues; // From @wix/form-viewer
  overrides: FormOverrides; // From @wix/form-viewer
  fieldProperties: WaiverFormsFieldProperties;
};

/**
 * Arguments for initializing waiver form controller (simplified, no services)
 */
export type InitWaiverFormControllerArgs = {
  formId: string;
};

/**
 * Form status enum for waiver forms
 */
export enum WaiverFormStatus {
  INITIALIZING = 'INITIALIZING',
  IDLE = 'IDLE',
  VALIDATING = 'VALIDATING',
  ERROR = 'ERROR',
}

/**
 * Form state for waiver widget
 */
export interface WaiverFormState {
  status: WaiverFormStatus;
  waiverForms: WaiverForms;
  formId?: string;
  errors: FormError[];
}

/**
 * Form error type
 */
export interface FormError {
  messageKey?: string; // Translation key for the error message
  message?: string; // Direct error message (fallback)
  field?: string;
  type?: string;
}
